<div class="grid-container margin-top">
    <tabs (tabClicked)="onTabClicked($event)">
        <tab title="New">
            <ag-grid-angular class="data-grid  full-page" [gridOptions]="pendingGridOptions" [rowData]="dataPending | async"  [excelStyles]="excelStyles" aria-label="New"></ag-grid-angular>
        </tab>
        <tab title="In Progress">
            <ag-grid-angular class="data-grid  full-page" [gridOptions]="progressGridOptions" [rowData]="dataProgress | async"  [excelStyles]="excelStyles" aria-label="In Progress"></ag-grid-angular>
        </tab>
        <tab title="Escalation Review">
            <ag-grid-angular class="data-grid  full-page" [gridOptions]="escalatedGridOptions" [rowData]="dataEscalated | async"  [excelStyles]="excelStyles" aria-label="Escalation Review"></ag-grid-angular>
        </tab>
        <tab title="Contested">
            <ag-grid-angular class="data-grid  full-page" [gridOptions]="contestedGridOptions" [rowData]="dataContested | async"  [excelStyles]="excelStyles" aria-label="Contested"></ag-grid-angular>
        </tab>
        <tab title="Closed">
            <ag-grid-angular class="data-grid  full-page" [gridOptions]="closedGridOptions" [rowData]="dataClosed | async"  [excelStyles]="excelStyles" aria-label="Closed"></ag-grid-angular>
        </tab>
    </tabs>
</div>